import type { SeoLandingSection } from "../types";
import { CalculatorCta } from "./calculatorCta";
import { CaseHighlight } from "./caseHighlight";
import { ComparisonSection } from "./comparisonSection";
import { FaqSection } from "./faqSection";
import { FinalCta } from "./finalCta";
import { HeroDireto } from "./heroDireto";
import { MetricsSection } from "./metricsSection";
import { NumberedSteps } from "./numberedSteps";
import { ProofStrip } from "./proofStrip";
import { SegmentPain } from "./segmentPain";
import { ShortAnswer } from "./shortAnswer";

type SeoSectionProps = {
  section: SeoLandingSection;
  updatedAt: string;
  onDemoClick: (location: "hero" | "cta_band") => void;
};

/** Escolhe o componente de cada section da config, na ordem em que vem. */
export const SeoSection = ({
  section,
  updatedAt,
  onDemoClick,
}: SeoSectionProps) => {
  switch (section.type) {
    case "hero":
      return <HeroDireto {...section} onCtaClick={() => onDemoClick("hero")} />;
    case "proof":
      return <ProofStrip {...section} />;
    case "shortAnswer":
      return <ShortAnswer {...section} />;
    case "pain":
      return <SegmentPain {...section} />;
    case "steps":
      return <NumberedSteps {...section} />;
    case "comparison":
      return <ComparisonSection {...section} />;
    case "case":
      return <CaseHighlight {...section} />;
    case "metrics":
      return <MetricsSection {...section} />;
    case "calculator":
      return <CalculatorCta {...section} />;
    case "faq":
      return <FaqSection {...section} updatedAt={updatedAt} />;
    case "finalCta":
      return (
        <FinalCta {...section} onCtaClick={() => onDemoClick("cta_band")} />
      );
  }
};
